/**
 * What the store needs before the driver has loaded: the picker has to open inside the click (it needs the user
 * activation), and loading manetta.ts first would spend it.
 */

/** The Manetta service, as in @taretto/manetta. Permanent (SPEC 2.1); manetta.test.ts checks the two match. */
export const MANETTA_SERVICE_UUID = '6d610001-4f1c-4a76-8efe-4240e27b7038';

/** Opens the browser's picker for Manetta devices. Call it synchronously inside the click. */
export function requestMachineDevice(): Promise<BluetoothDevice> {
  // One filter, by service UUID, which Bluefy takes too (SPEC 7).
  return navigator.bluetooth.requestDevice({ filters: [{ services: [MANETTA_SERVICE_UUID] }] });
}
